import type { Axios } from 'axios';
import { get, writable } from 'svelte/store';
import { apiStore } from './api';

export type Tag = string;

export const tagStore = writable<Tag[]>([]);

export function loadTags() {
	(get(apiStore) as Axios).get('/business/tags').then((res) => {
		loadTagsFromData(res.data);
	});
}

export function loadTagsFromData(data: Tag[]) {
	tagStore.set(data);
}
